export function startSpin(show){
	var $preload    = $('body').find('.preload')
	if($preload.length){
		$preload.remove()
	}
	
	if(show){
		$('body').append(`<div class="preload" style="position: fixed;left: 0;bottom: 0;right: 0;top: 0;background-color: rgba(0, 0, 0, 0.7);z-index: 2000;">
							<div style="text-align: center; margin: 12rem auto">
								<div class="preloader-wrapper big active">
									<div class="spinner-layer spinner-white">
										<div class="circle-clipper left">
											<div class="circle"></div>
										</div>
										<div class="gap-patch">
											<div class="circle"></div>
										</div>
										<div class="circle-clipper right">
											<div class="circle"></div>
										</div>
									</div>
								</div>
							</div>
						</div>`);
	}
}

export function createLoader(show){
	if(show){
		if($('#cubre-page').length == 0){
			$('body').append('<div id="cubre-page" style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;background-color: rgba(0, 0, 0, .1);z-index: 99999;"></div>')
		}
		$('.capa, .progress').show()
	}
	else{
		$('.capa, .progress').hide()
		$('#cubre-page').remove()
	}
}


export function addCerrar(modal){
	if($(modal).attr('data-close') === 'false') return;
	
	let instances     = M.Modal.getInstance(modal)
	,    $close    = $('<button class="btn btn-flat btn-close"><i class="material-icons">close</i></button>')
	$(modal).prepend($close)
	_dataForm 	= null;
	$close.css({position: 'absolute', right: '.375rem', top: '.375rem' })

	$close.on('click', function(event){
		event.stopPropagation()
		event.preventDefault()
		instances.close()
		$close.remove()
		if(_dataForm !== null){
			if(_dataForm.status.reload){
				window.location.reload()
			}
		}
	})
}



export function iniciarForms($forms){
	$forms 	= $forms == undefined ? $('form:visible') : $forms	
	if($().datetimepicker != undefined){
		$.datetimepicker.setLocale('es');

		$forms.each(function(){
			let  $dateTime         = $(this).find('[data-tipo="date"], [data-tipo="datetime"]')
		    $dateTime.each(function(index, element) {
		    	crearDateTime($(this))		      
		    }); 

			let $timePicker     = $(this).find('[data-tipo="time"]')
		    $timePicker.datetimepicker({format:'H:i', timepicker: true, datepicker: false});  
			
	    })
	}

	if($().datetextentry != undefined){
		$forms.find('.datetextentry').each(function(){
			$(this).datetextentry()		
		})
	}

	if($().chosen != undefined){
		$forms.find('.chosen').each(function(){
			$(this).chosen({width: "100%", max_shown_results: 6})
		})
	}

	$forms.filter(':visible[data-captcha="true"]').each(function(){
		obtenerCaptcha($(this).attr('id'));
    });
	 

	$forms.filter(':not(.excluir)').find('[data-send="true"]').on('click', function(event){
		event.stopPropagation()
		event.preventDefault()
		let $este           = $(this)
		if($este.attr('data-disable') == 'true') return false
		$este.parents('form').submit()
	})


	$forms.filter(':not(.excluir)').each(function(index, data){
		let $form 	= $(this)
		$form.find('.politica[data-tdoc]:not(.custom)').each(function(index, data){
			traerPolitica($(this), {}, $form.find('[data-send]'))
		})
	})

	$forms.filter(':not(.excluir)').each(function(index, data){
		let $form  	= $(this)
		,	obj 	= {
			onfocusout: function(element) {
				$(element).valid()
			},
			invalidHandler: function (event, validator) {
				console.log(event, validator)
				M.toast({html: 'Revisa los campos obligatorios'})
			},
			submitHandler: function (form) {
				//console.log('submitHandler', form);		
				let $btn 	= $(form).find('[data-send]')		
				$.ajax({	
						url 		: $(form).attr('action'),
			            type 		: 'POST',
			            data 		: new FormData(form),
			            processData	: false,
						contentType	: false, 
			            dataType	: 'json',
						beforeSend: function(){
							$btn.attr('data-disable', 'true')
							createLoader(true)                   
						},
						success: function(data){
							createLoader(false)								
							_dataForm 		= data
							afterSubmit(data, $(form), $btn)
						},
						error: function(xhr, status){
							console.log(xhr.responseText)
							M.toast({html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'})
							createLoader(false)  
							$btn.attr('data-disable', 'false') 
						}
					})
			},
			success: function (label, element) {

			}
		};

		if($form.attr('data-password') == 'true'){
			obj.rules 	= {
				password: {
					required: true, 
					minlength: 6
				},
				password_confirm: {
		            required: true,
		            minlength: 5,
		            equalTo: "#change_password"
		        }
			}
    	}
		$form.validate(obj)
	});
	M.updateTextFields();	
}

export function traerPolitica($politica, extraData = {}, $boton = undefined){
	$politica.each(function(){
		let $esto 		= $(this)
		,	$info 		= $esto.find('.info')
		,	$checkbox 	= $esto.find('.checkboxes [type="checkbox"].checkbox')
		,	tdoc 		= $esto.data('tdoc')		
		,	changes 	= $esto.hasClass('changes')

		$esto.find('.boton-ver').remove();		
		extraData.tipo 	= tdoc
		
		obtenerTerminos(extraData, function(info){
			if(info === false){
				M.toast({html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'})
			}
			else{
				// console.log(info[ix].code)
				let ix = Object.keys(info)[0]				
				$info.html('<div class="c-info" style="display:none">' + info[ix].documento + '</div>')
				$checkbox.val(info[ix].code)

				if(changes){
					$esto.find('legend').text(info[ix].titulo)
				}
				
				setTimeout(function(){
					let width 	= $info.outerWidth()
					$info.css({width: width + 'px', 'margin-bottom': '.75rem'})
					$info.find('.c-info').fadeIn('fast')
					$(`<div class="center-align boton-ver"><a href="${_ULANG + _URI.ver}/?code=${info[ix].code}" target="_blank" class="waves-effect waves-light btn-small verde-full"><i class="material-icons left">remove_red_eye</i>${'Ver documento'}</a></div>`)
							.insertBefore($esto.find('.checkboxes'))
				evaluarScrolls($info, $checkbox, $boton)	
				}, 500)								
			}
		})	
	})
}

export function evaluarScrolls($infoScroll, $checkbox, $boton = undefined){
	let porcentaje = (($infoScroll.scrollTop() + $infoScroll.innerHeight()) / $infoScroll[0].scrollHeight) * 100;
	if (porcentaje >= 95) {
		$checkbox.prop('readonly', false)
		if($boton != undefined){
			checkTerms($checkbox, $boton)
		}
		return;
	}

	$checkbox.prop('readonly', true);
	$checkbox.attr('data-terms', 'true');

	if($boton !== undefined){
		$boton.prop('disabled', true).attr('data-disable', true);
	}

	$checkbox.prop('checked', false)
	$checkbox.off('click')
	$checkbox.on('click', function(event){
		if($(this).prop('readonly')){
			M.toast({html: 'Antes de chequear esta casilla, debes leer el documento'})
			return false;
		}
	})
	
	$infoScroll.on('scroll', function (event){
		let porcentaje = (($(this).scrollTop() + $(this).innerHeight()) / $(this)[0].scrollHeight) * 100;
		if (porcentaje >= 95) {
			$checkbox.prop('readonly', false)
			if($boton != undefined){
				checkTerms($checkbox, $boton)
			}
			$(this).off('scroll')			
		}
	});
}

function checkTerms($checkbox, $boton){
	$checkbox.on('change', function (event){
		let $form 		= $(this).parents('form')
		, 	$checkboxes	= $form.find('[data-terms="true"]:not(:checked)')
		$boton.prop('disabled', $checkboxes.length != 0).attr('data-disable', $checkboxes.length != 0 ? 'true' : 'false')
	})
}

export function setDefaults(){
	if($.validator != undefined){
		jQuery.extend(jQuery.validator.messages, {
			required: "Este campo es obligatorio.",
			remote: "Por favor, rellena este campo.",
			email: "Por favor, escribe una dirección de correo válida",
			url: "Por favor, escribe una URL válida.",
			date: "Por favor, escribe una fecha válida.",
			dateISO: "Por favor, escribe una fecha (ISO) válida.",
			number: "Por favor, escribe un número entero válido.",
			digits: "Por favor, escribe sólo dígitos.",
			creditcard: "Por favor, escribe un número de tarjeta válido.",
			equalTo: "Por favor, escribe el mismo valor de nuevo.",
			accept: "Por favor, escribe un valor con una extensión aceptada.",
			maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
			minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
			rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
			range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
			max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
			min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
		});

		$.validator.setDefaults({
			errorClass: 'invalid',
			validClass: "valid",
	  		errorPlacement: function(error, element) {
	  			let $form 	= element.closest("form")
	  			// ,	$label 	= $form.find("label[for='" + element.attr('id') + "']")
	  			,	isCheck = element.attr('type') == 'checkbox' || element.attr('type') == 'radio'
	  			,	$el 	= $form.find("label[for='" + element.attr('id') + "']")

	  			if(isCheck){
	  				$el 	= element.parents('label').first()
	  			}
	  			else if(element.attr('type') == 'file'){
	  				$el 	= element.parents('.file-field').find('.file-path')
	  			}
	  			else if(element.hasClass('browser-default')){
	  				$el 	= element
	  			}

	  			if(error.text() == ''){
		  			$el.next('.helper-text').remove()	
	  			}
	  			else{
		  			
	  				let $span	= $el.next('.helper-text')
	  				if($span.length == 0){
	  					$('<span class="helper-text" data-error="' + error.text() + '">' + error.text() + '</span>').insertAfter($el)
	  				}
	  				else{
	  					//$span.attr('data-error', error.text())
	  					$span.text(error.text())
	  				} 	
		  			
				}
			}
		});
	}
	
}

export function ponerCaptchaModal($modal){
	$modal.find('form[data-captcha="true"]').each(function(){
		obtenerCaptcha($(this).attr('id'));
    });
}

export function afterSubmit(data, $form = undefined, $boton = undefined){
	let status      = data.status
	,   callback    = function(status){

						if(status.go_to != ''){
							window.location.href    = status.go_to       
							return true;
						}

						if(status.close){
							let $modal 	= $form.parents('.modal')
							if($modal.length != 0){
								let instance 	= M.Modal.getInstance($modal.get(0))
								instance.close()
							}
						}

						if(status.reload){
							window.location.reload()
							return true;
						}
					}

	if(status.reset && $form != undefined && !status.error){
		$form.get(0).reset()
	}

	if(status.captcha){
		obtenerCaptcha($form.attr('id'));
	}
	M.updateTextFields()

	if(typeof data.consola === 'object'){
		console.log(data.consola)
	}

	if(status.localstorage){
		for(let keys in status.localstorage){
			window.localStorage.setItem(keys, JSON.stringify(status.localstorage[keys]))
		}
	}

	if(data.messages.length != 0){
		afterSubmitToast(data.messages, function(){
			callback(status);
		});
	   
	}
	else{
		callback(status);
	}

	if(typeof $boton !== 'undefined'){
		$boton.attr('data-disable', 'false') 
	}

	if(status.functions.length != 0){
		for(let k in status.functions){
			if(typeof window[status.functions[k]] === 'function'){
				window[status.functions[k]](data)
			}
		}
	}
}

function afterSubmitToast(messages, callback = undefined){
	if(messages.length == 0){
		if(typeof callback === 'function'){
			callback()
		}
	}
	else{
		let messages_str = 	'<div>' + messages.join('<br />') + '</div>'
       					+ 	`<button class="btn-flat toast-action" onClick='M.Toast.getInstance(this.parentElement).dismiss();'>Cerrar</button>`

		M.toast({html: messages_str, displayLength: 6000, completeCallback: callback})        
	}
}

export function obtenerTerminos(data, callback){
	$.ajax({
		type: 		"POST",
		url: 		'/action/terminos/',
		data: 		data,
		dataType: 	'json',
		beforeSend: function(){
			createLoader(true)
		},
		success: 	function(data){
			createLoader(false)
			if(data.ans.transaction == 'OK'){
				callback(data.ans.documents)
			}
			else{
				callback(false)	
			}
		}
	});
}

export function obtenerCaptcha(formId){
	if(!_CAPTCHA)     return false; 

	let $form     = $('#' + formId)
	,    $btn     = $form.find('[data-send="true"]')
	$btn.addClass('disabled').attr('data-disable', 'true')
	grecaptcha.ready(function() {
		grecaptcha.execute(_CAPTCHA_WEBS, {action: $form.attr('action')}).then(function(token) {
			let $input  = $form.find('[name="g-recaptcha-response"]');
			if($input.length == 0) $input = $('<input type="hidden" name="g-recaptcha-response" />').appendTo($form)
			$input.val(token)
			$btn.removeClass('disabled').attr('data-disable', 'false')
		});
	});
}

export function readURL(input, $img) {
	if (input.files && input.files[0]) {
		let reader = new FileReader();
		reader.onload = function (e) {           
			$img.attr('src', e.target.result);
		}
		reader.readAsDataURL(input.files[0]);
	}
	else{
		$(input).parents('.file-field').find('.file-path').text('')
		$img.attr('src', $img.attr('data-src'));
	}
}



// Mejorar números
export function addCommas(nStr){
	nStr     += '';
	let   x = nStr.split('.')
	,    x1 = x[0]
	,    x2 = x.length > 1 ? ',' + x[1] : ''
	,    rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + '.' + '$2');
	}
	return x1 + x2;
}


export function getScript(url, success){
    var script = document.createElement('script');
    script.src = url;
    var head = document.getElementsByTagName('head')[0], done=false;
    script.onload = script.onreadystatechange = function(){
        if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
            done=true;            
            script.onload = script.onreadystatechange = null;
            head.removeChild(script);
             if(typeof success == 'function') success();
        }       
    };
    try {
        head.appendChild(script);       
    }
    catch(err) {
        console.log(err.message);
    }
}


export function jSONInfo(config, option, callBack){
	let cnfAjax={
			url:        config.action
		,   type:       config.type
		,   data:       option
		,   dataType:   "json"
		,   success: function(data) {           
				if(typeof callBack == 'function') callBack(data);
			}
		,   error: function (jqXHR, textStatus, errorThrown){
				console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
			}
		}
	,   $files  = config.Files

	$.ajax(cnfAjax).fail( function( jqXHR, textStatus, errorThrown ) {
    	console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
	});
}

export function validateUser(){
	return validate
}

export function obtenerOffsetMenu(element){
	if(element == undefined) return;
	let invisibleItems = [];
	for(var i=0; i<element.childElementCount; i++){
		if (element.children[i].offsetTop + element.children[i].offsetHeight >
				element.offsetTop + element.offsetHeight ||
				element.children[i].offsetLeft + element.children[i].offsetWidth >
				element.offsetLeft + element.offsetWidth ){
			invisibleItems.push(element.children[i]);
		}
	}
	return invisibleItems;
}


export function espCalendar(){
    return {cancel:  'Cerrar'
        ,   clear:   'Limpiar'
        ,   done:    'Aceptar'
        ,   previousMonth:   '‹'
        ,   nextMonth:   '›'
        ,   months:  
                [
                  'Enero',
                  'Febrero',
                  'Marzo',
                  'Abril',
                  'Mayo',
                  'Junio',
                  'Julio',
                  'Agosto',
                  'Septiembre',
                  'Octubre',
                  'Noviembre',
                  'Diciembre'
                ]
                      
        ,   monthsShort : [
                    'Ene',
                    'Feb',
                    'Mar',
                    'Abr',
                    'May',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dic'
                ]                      
        ,   weekdays : [
                  'Domingo',
                  'Lunes',
                  'Martes',
                  'Miercoles',
                  'Jueves',
                  'Viernes',
                  'Sábado'
                ]
                      
        ,   weekdaysShort : [
                  'Dom',
                  'Lun',
                  'Mar',
                  'Mie',
                  'Jue',
                  'Vie',
                  'Sáb'
                ]                      
        , weekdaysAbbrev :  ['D','L','M','M','J','V','S']}
}


export function obtenerData(slugVista, keyVista, callback){
	$.ajax({
		type: 		"POST",
		url: 		'/action/data-vista/',
		data: 		{slugVista: slugVista, keyVista: keyVista},
		dataType: 	'json',
		beforeSend: function(){
			createLoader(true)
		},
		success: 	function(data){
			createLoader(false)
			callback(data.ans)			
		}
	});
}


// WEBPACK FOOTER //
// ./src/js/utils.js